export default "__VITE_ASSET__BjbOxzI0__"